export enum CardsMultiSelectMode {
    None,       //no multi-select enabled
    Undecided,  //multi-select started, but no function selected yet
    AddToParent,
    Remove,
    RequestStory,
}

export enum FcstCardsMultiSelectMode {
    None,       //no multi-select enabled
    Undecided,  //multi-select started, but no function selected yet
    Collapse,
    Remove,
}